import { useState, useEffect } from 'react';
import axios from 'axios';

// eslint-disable-next-line no-undef
const getOrganizationsFromStorage = () => window.sessionStorage.getItem('OrganizationsData');

/**
 *
 * @returns {object}
 */
function useGetOrganizationsData() {
  const [responseData, setResponseData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const controller = new AbortController();

  useEffect(() => {
    const storedOrganizationsData = getOrganizationsFromStorage();
    if (storedOrganizationsData) {
      setResponseData(JSON.parse(storedOrganizationsData));
    } else {
      const getOrganizations = async () => {
        try {
          setIsLoading(false);
          const res = await axios.get('api/organisations', { signal: controller.signal });
          const organisationsData = res.data;
          setResponseData(organisationsData);
          // eslint-disable-next-line no-undef
          window.sessionStorage.getItem('OrganizationsData', JSON.stringify(organisationsData));
          setError(null);
        } catch (e) {
          setError(e);
          setIsLoading(false);
        }
      };
      getOrganizations();
      return () => controller.abort();
    }
  }, []);

  return { responseData, isLoading, error };
}

export default useGetOrganizationsData;
